module.exports = __webpack_public_path__ + "img/logins1.png";